import { BUILDER } from '../../../../src/shared/abilities';
import compose from '../../../../src/web/utils/react/compose';
import pure from '../../../../src/web/utils/react/pure';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import editor from '../../../../src/web/components/widgets/decorators/editor';
import StandardUnitListing from './StandardUnitListing';
import Editor from './Editor';
import { NAME, ID } from './properties';

const component = compose(
  editor(Editor),
  widget(
    { name: NAME, category: 'Unit Displays', componentId: ID },
    {
      defaults: {
        content: '<div>Click here to add content</div>',
        height: '315',
        scrollbars: false,
        border: false,
      },
    },
    pure(),
  ),
)(StandardUnitListing);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
